import type { BillingState, EnterpriseOfferReview, Invoice, PaymentPage, Plan } from "@backstory/protocol";
import { request } from "../../api";

const enc = encodeURIComponent;

export interface CheckoutResult {
  url: string;
}

/** Payment APIs that do not exist in a self-hosted build. */
export const saasBillingApi = {
  state: (org: string) => request<BillingState>(`/v1/orgs/${enc(org)}/billing`),
  checkout: (org: string, plan: Plan, interval: "month" | "year") =>
    request<CheckoutResult>(`/v1/orgs/${enc(org)}/billing/checkout`, { method: "POST", body: { plan, interval } }),
  aiCreditWallet: (org: string) =>
    request<{ balanceUsd: number }>(`/v1/orgs/${enc(org)}/billing/ai-credits`),
  aiCreditCheckout: (org: string, amountUsd: 25 | 50 | 100) =>
    request<CheckoutResult>(`/v1/orgs/${enc(org)}/billing/ai-credits/checkout`, { method: "POST", body: { amountUsd } }),
  portal: (org: string) => request<CheckoutResult>(`/v1/orgs/${enc(org)}/billing/portal`, { method: "POST" }),
  cancel: (org: string, immediate: boolean) =>
    request<BillingState>(`/v1/orgs/${enc(org)}/billing/cancel`, { method: "POST", body: { immediate } }),
  invoices: (org: string) =>
    request<{ items: Invoice[] } | Invoice[]>(`/v1/orgs/${enc(org)}/billing/invoices`).then((r) => (Array.isArray(r) ? r : r.items)),
  payments: (org: string, cursor?: string) =>
    request<PaymentPage>(`/v1/orgs/${enc(org)}/billing/payments${cursor ? `?cursor=${enc(cursor)}` : ""}`),
  enterpriseOffer: (org: string, offer: string) =>
    request<EnterpriseOfferReview>(`/v1/orgs/${enc(org)}/billing/enterprise-offers/${enc(offer)}`),
  acceptEnterpriseOffer: (org: string, offer: string) =>
    request<EnterpriseOfferReview>(`/v1/orgs/${enc(org)}/billing/enterprise-offers/${enc(offer)}/accept`, { method: "POST", body: {} }),
};
